interface TermItem {
  id: string
  titleId: string
  bodyId: string
}

/**
 * The T&C copy itself lives in `intl/copy/<locale>.json` keyed by `titleId` /
 * `bodyId` so it renders in the respondent's selected language. Bodies are ICU
 * rich-text messages using the tags defined in `termsRichText.tsx`.
 */
export const getTerms: TermItem[] = Array.from({ length: 22 }, (_, index) => {
  const term = index + 1
  return {
    id: `4fcb18f7-5a17-44d1-89cf-df4a9b9f1${100 + term}`,
    titleId: `termsPage_term${term}_title`,
    bodyId: `termsPage_term${term}_body`
  }
})
